// This creates a single instance of i18n that can be used across the app for
// localizing things. This can be done safely through just the import since the
// entire app is reloaded when a language is changed.

import { setupI18n, I18n } from '@lingui/core'

interface FixedI18n extends I18n {
  number(
    value: number,
    options: {
      style?: 'currency'
      currency?: string
    },
  ): string
}

export default setupI18n() as FixedI18n
